import React, { useEffect, useState } from "react";
import Async from "react-select/async";
import Select from "react-select";
import {
    Card,
    CardBody,
    Col,
    Form,
    FormGroup,
    Input,
    Label,
    Row,
    TabContent,
    TabPane,
    Progress,
    NavLink,
    NavItem,
    Button,
    CardTitle,
    FormFeedback,
    FormText,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    Badge,
    DropdownItem,
} from "reactstrap";
import classnames from "classnames";
import { Link, Navigate, useParams } from "react-router-dom";
import {
    clearUpdateRoomDetailsError,
    getSchedulerDetails,
    updateRoomDetails,
    updateSwitchDetails
} from "../../../store/deviceDetails/actions.js";
import {
    getAssignableGroupsForAsyncSelect,
    getAssignableSwitchCategoryForAsyncSelect
} from "../../../store/device/actions.js";
import { connect } from "react-redux";
import { CUSTOMER } from "../../../store/users/role.constants.js";
import { updateForm } from "../../../store/form/actions.js";
import Message from "../../../CommonData/Data/Message.js";
import VWLoading from "../../../components/vwLoading/vwLoading.js";
import _ from 'lodash';

const FormWizard = (props) => {

    const { currentProfile, masterDeviceDetails, form, errorMessage, isSuccess, isPending } = props;
    const [activeTabwiz, setoggleTabwiz] = useState(1);
    const [passedStepswiz, setpassedStepswiz] = useState([1]);
    const [selectedGroup, setSelectedGroup] = useState("");
    const [deviceDetails, setDeviceDetails] = useState({});
    const [open, setOpen] = useState([]);
    const [schedulerDetails, setSchedulerDetails] = useState();
    const [schedulerName, setSchedulerName] = useState();
    const [schedulerError, setSchedulerError] = useState();
    const [schedulerLoading, setSchedulerLoading] = useState(false);
    // const params = useParams();
    // const { key } = params;
    const queryString = window.location.pathname;
    const urlParams = queryString && queryString.split("/");
    const key = urlParams && urlParams[5];
    const reqParams = (urlParams && urlParams.length) > 0 ? urlParams[2] : null;

    useEffect(() => {
        const device = masterDeviceDetails && masterDeviceDetails.assignedDevices &&
            masterDeviceDetails.assignedDevices.filter((i) => i.id === key);
        if (device) {
            setDeviceDetails({
                ...device[0],
                roomName: device[0].roomName ?? "",
                roomNo: device[0].roomNo ?? "",
            });
            const group = {
                label: (device && device[0].group && device[0].group.name) || "none",
                value: (device && device[0].group && device[0].group.id) || ""
            }
            setSelectedGroup(group);
            props.updateForm({
                formUpdateRoom: {
                    formUpdateRoom1: {
                        roomName: device[0].roomName ?? "",
                        roomNo: device[0].roomNo ?? "",
                        selectedGroup: group,
                        ...device[0]
                    },
                    formUpdateRoom2: {
                        switches: device[0].switches
                    },
                    // device: { },
                    errors1: {},
                    errors2: {},
                }
            })
        }

        props.clearUpdateRoomDetailsError();
        return () => {
            props.clearUpdateRoomDetailsError();
        }
    }, []);

    //-------------------------------TAB-1--------------------------------------------------------------
    const handleInputChange1 = (event) => {
        const { name, value } = event.target;
        setDeviceDetails({ ...deviceDetails, [name]: value });
        props.updateForm({
            formUpdateRoom: {
                ...form.formUpdateRoom,
                formUpdateRoom1: {
                    ...form.formUpdateRoom.formUpdateRoom1,
                    [name]: value
                },
                errors1: {
                    ...form && form.formUpdateRoom.errors1,
                    [name]: name === "roomName" && ((value && value.length) > 15) ? "Room name should not exceed 15 characters" : null,
                }
            }
        });
    }

    const handleLoadGroups = (inputValue, callback) => {
        const { masterDeviceDetails } = props;
        const masterDeviceId = masterDeviceDetails && masterDeviceDetails.id;
        if (masterDeviceId) {
            props.getAssignableGroupsForAsyncSelect(masterDeviceId, inputValue, callback)
        }
        else {
            callback([]);
        }
    };

    const AddGroupChange = (value) => {
        setDeviceDetails({ ...deviceDetails, selectedGroup: value });
        setSelectedGroup(value);
        props.updateForm({
            formUpdateRoom: {
                ...form.formUpdateRoom,
                formUpdateRoom1: {
                    ...form.formUpdateRoom.formUpdateRoom1,
                    selectedGroup: value
                },
                errors1: {
                    ...form && form.formUpdateRoom.errors1,
                    selectedGroup: null,
                }
            }
        });
    }

    //-----------------------------------TAB-2--------------------------------------------------------
    const [switchList, setSwitchList] = useState();

    useEffect(() => {
        let switchLists = (deviceDetails && deviceDetails.switches && deviceDetails.switches.sort((a, b) => a.switchNo - b.switchNo)) || [];
        // let switchList = (deviceDetails && deviceDetails.switches) || [];
        setSwitchList(switchLists)
    }, [deviceDetails])

    const handleCategoriesOption = (inputValue, callback) => {
        const { getAssignableSwitchCategoryForAsyncSelect } = props;
        getAssignableSwitchCategoryForAsyncSelect(inputValue, callback)
    };

    useEffect(() => {
        if ((switchList && switchList.length > 0)) {

            const updatedSwitchList = [...switchList]

            const switch1Index = updatedSwitchList && updatedSwitchList.findIndex((i) => Number(i.switchNo) === 1)
            const switch2Index = updatedSwitchList && updatedSwitchList.findIndex((i) => Number(i.switchNo) === 2)
            if (switch2Index >= 0 && switch1Index >= 0) {
                updatedSwitchList[switch2Index].switchName = "speed ++";
                updatedSwitchList[switch2Index].switchCategory = "Speed Controller";
                updatedSwitchList[switch2Index].disabled = updatedSwitchList[switch1Index].isEnabled ? false : true;
            }

            const switch3Index = updatedSwitchList && updatedSwitchList.findIndex((i) => Number(i.switchNo) === 3)
            if (switch3Index >= 0 && switch1Index >= 0) {
                updatedSwitchList[switch3Index].switchName = "speed --";
                updatedSwitchList[switch3Index].switchCategory = "Speed Controller";
                updatedSwitchList[switch3Index].disabled = updatedSwitchList[switch1Index].isEnabled ? false : true;
            }
            setSwitchList(updatedSwitchList)
        }
    }, [form])

    const checkDuplicateNo = () => {
        const switchNoList = switchList && switchList.map((i) => Number(i.switchNo))
        const uniqueArray = _.uniqWith(switchNoList, _.isEqual);
        const duplicateStatus = (uniqueArray && uniqueArray.length) !== (switchNoList && switchNoList.length);
        return duplicateStatus;
    }

    const isEndUser = currentProfile.roles && currentProfile.roles.length > 0 &&
        currentProfile.roles[0].roleKey === CUSTOMER;

    const switchDataOnChange = (event, switchData, index) => {
        const input = event.target;
        const value = input.type === "checkbox" ? input.checked : input.value;
        let switchListError = [...switchList];

        if ((input && input.name) === "isEnabled") {
            const indexSwitch2 = switchList.findIndex((i) => Number(i.switchNo) === 2);
            const indexSwitch3 = switchList.findIndex((i) => Number(i.switchNo) === 3);
            if (Number(switchList && switchList[index].switchNo) === 1) {
                if (indexSwitch2 >= 0 && indexSwitch3 >= 0) {
                    switchList[indexSwitch2].isEnabled = value;
                    switchList[indexSwitch3].isEnabled = value;
                    if (!value) {
                        switchList[indexSwitch2].disabled = true;
                        switchList[indexSwitch3].disabled = true;
                    }
                    else {
                        switchList[indexSwitch2].disabled = false;
                        switchList[indexSwitch3].disabled = false;
                    }
                }
            }
            else if ((Number(switchList && switchList[index].switchNo) === 2) || (Number(switchList && switchList[index].switchNo) === 3)) {
                if (indexSwitch2 >= 0 && indexSwitch3 >= 0) {
                    switchList[indexSwitch2].isEnabled = value;
                    switchList[indexSwitch3].isEnabled = value;
                }
            }
        }

        if ((input && input.name) === "switchNo") {
            let updatedSwitchList = [...switchList];
            const checkSwitchNo = updatedSwitchList && updatedSwitchList.filter((i) => (i.switchNo && i.switchNo.toString()) === value.toString())
            const isPresent = (checkSwitchNo && checkSwitchNo.length) !== 0
            if (isPresent && value !== "") {
                const switchNoError = "Already this number used";
                switchData.switchNoError = switchNoError;
                switchListError[index] = switchData;
            }
            else {
                const switchNoError = "";
                switchData.switchNoError = switchNoError;
                switchListError[index] = switchData;
            }

            const switchListLength = switchList && switchList.length
            if (switchListLength <= Number(value)) {
                const switchNoError = "Invalid switch number";
                switchData.switchNoError = switchNoError;
                switchListError[index] = switchData;
            }
        }
        if ((input && input.name) === "switchName") {
            if ((value && value.length) > 10) {
                switchData.switchNameError = "Switch name should not exceed 10 characters";
                switchListError[index] = switchData;
            }
            else {
                switchData.switchNameError = "";
                switchListError[index] = switchData;
            }
        }

        switchData[input.name] = value;
        switchList[index] = switchData;
        setSwitchList(switchList);
        const switchNoDuplicate = checkDuplicateNo();

        if (!switchNoDuplicate) {
            switchListError && switchListError.map((data) => data.switchNoError = null);
        }

        props.updateForm({
            formUpdateRoom: {
                ...form.formUpdateRoom,
                formUpdateRoom2: {
                    ...form.formUpdateRoom.formUpdateRoom2,
                    switches: switchList
                },
                errors2: {
                    ...form && form.formUpdateRoom.errors2,
                    ...switchListError,
                }
            }
        });
    };

    const switchDataOnSelect = (values, switchData, index) => {
        const { value } = values || {};
        switchData["switchCategory"] = value;
        switchList[index] = switchData;
        props.updateForm({
            formUpdateRoom: {
                ...form.formUpdateRoom,
                formUpdateRoom2: {
                    ...form.formUpdateRoom.formUpdateRoom2,
                    switches: switchList
                },
                errors1: {
                    ...form && form.formUpdateRoom.errors1,
                    switches: null,
                }
            }
        });
    };

    // ----------------------------------------SORTING-----------------------------------------------------------//
    const [sortDirection, setSortDirection] = useState('asc');
    const [sortOrder, setSortOrder] = useState(null);
    const handleSort = (column) => {
        if (sortOrder === column) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setSortOrder(column);
            setSortDirection('asc');
        }
    };
    switchList && switchList.sort((a, b) => {
        if (sortOrder === 'switchNo') {
            const aVal = parseFloat(a[sortOrder] || 0);
            const bVal = parseFloat(b[sortOrder] || 0);
            return sortDirection === 'asc' ? aVal - bVal : bVal - aVal;
        }
        else {
            const aValue = a[sortOrder] || 'NA';
            const bValue = b[sortOrder] || 'NA';
            return sortDirection === 'asc' ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
        }
    });


    //---------------------VALIDATION & PAGE NAVIGATION-----------------------------------------------------------
    const toggleTabwiz = (tab) => {
        const { formUpdateRoom } = form || {};
        const { formUpdateRoom1, formUpdateRoom2, errors1, errors2 } = formUpdateRoom || {};
        const { roomNo, roomName } = formUpdateRoom1 || {};
        const { switches } = formUpdateRoom2 || {};

        let errors = {};
        const currentErrors1 = {};
        let currentErrors2 = [...switches];
        //---------------------TAB-1-----------------------------------------------------------
        if (activeTabwiz === 1) {
            if (!roomNo) {
                currentErrors1.roomNo = "Room no is required"
            }
            if (!roomName) {
                currentErrors1.roomName = "Room name is required"
            }
            if (errors1 && errors1.roomName) {
                currentErrors1.roomName = "Room name should not exceed 15 characters"
            }
            props.updateForm({
                formUpdateRoom: {
                    ...formUpdateRoom,
                    formUpdateRoom1: {
                        ...form.formUpdateRoom.formUpdateRoom1,
                    },
                    errors1: currentErrors1,
                }
            })
            errors = currentErrors1;
        }
        if (activeTabwiz === 2) {
            switches.map((i, index) => {
                if ((i.switchNo === null || i.switchNo === '')) {
                    currentErrors2[index] = { ...currentErrors2[index], switchNoError: "Switch no is required" };
                }
                if (!(i.switchName)) {
                    currentErrors2[index] = { ...currentErrors2[index], switchNameError: "Switch name is required" }
                }
            })
            props.updateForm({
                formUpdateRoom: {
                    ...formUpdateRoom,
                    formUpdateRoom2: {
                        ...form.formUpdateRoom.formUpdateRoom2,
                    },
                    errors2: currentErrors2,
                }
            })
            errors = currentErrors2.filter((i) => i.switchNoError || i.switchNameError || i.switchCategoryError);
        }

        if (Object.keys(errors).length === 0) {
            if (activeTabwiz !== tab) {
                var modifiedSteps = [...passedStepswiz, tab];
                if (tab >= 1 && tab <= 3) {
                    setoggleTabwiz(tab);
                    setpassedStepswiz(modifiedSteps);
                }
            }
        }
        else {
            if (activeTabwiz > tab) {
                var modifiedSteps = [...passedStepswiz, tab];
                if (tab >= 1 && tab <= 3) {
                    setoggleTabwiz(tab);
                    setpassedStepswiz(modifiedSteps);
                }
            }
        }
    }

    const handleUpdateRoomDetails = (e) => {
        e.preventDefault();
        const { masterDeviceDetails } = props;
        const data = {
            ...form.formUpdateRoom.formUpdateRoom1,
            ...form.formUpdateRoom.formUpdateRoom2,
        }
        props.updateRoomDetails(deviceDetails.id, masterDeviceDetails.id, data);
    };

    const handleSchedulerData = (e, id, name) => {
        e.preventDefault();
        const selectedSwitch = [...open];
        const isAlreadyPresent = selectedSwitch && selectedSwitch.findIndex((i) => i.id === id)
        selectedSwitch && selectedSwitch.map((i) => {
            if (i.id !== id) {
                return i.isOpen = false
            }
        });

        if (isAlreadyPresent === -1) {
            selectedSwitch.push({ id: id, isOpen: true })
        }
        else {
            selectedSwitch[isAlreadyPresent].isOpen = selectedSwitch[isAlreadyPresent].isOpen ? false : true;
        }

        setOpen(selectedSwitch)

        if (id) {
            setSchedulerLoading(true);
            props.getSchedulerDetails(id)
                .then((result) => {
                    setSchedulerLoading(false);
                    setSchedulerError();
                    setSchedulerName(name);
                    if (result) {
                        const { schedulerconfig } = result || {};
                        const newArr = Object.entries(schedulerconfig);
                        newArr && newArr.map((ele) => {
                            return ele.splice(0, 1, [{ day: ele[0] }])
                        })
                        const combinedArr = newArr && newArr.map((i) => i.flat());
                        const reduceArr = combinedArr && combinedArr.filter((ele) => ele.length > 1);
                        const finArr = reduceArr && reduceArr.map((ele) => {
                            return ele.map((i) => {
                                return {
                                    ...i,
                                    day: ele[0].day
                                }
                            })
                        })
                        finArr && finArr.map((ele) => {
                            return ele.splice(0, 1)
                        })
                        const schedulerData = [];
                        const mergedArr = finArr.flat();
                        mergedArr && mergedArr.map((ele) => {
                            const index = schedulerData && schedulerData.findIndex((i) => (ele.actionTime === i.actionTime) && (ele.status === i.status));
                            let temObj = {};
                            if (index === -1) {
                                temObj = {
                                    actionTime: ele.actionTime,
                                    days: [ele.day],
                                    status: ele.status,
                                    isActionExecuted: ele.isActionExecuted
                                }
                                return schedulerData.push(temObj);
                            }
                            else {
                                return schedulerData[index].days.push(ele.day);
                            }
                        })
                        setSchedulerDetails(schedulerData);
                    }
                })
                .catch((err) => {
                    setSchedulerName(name);
                    setSchedulerError(err);
                    setSchedulerLoading(false);
                })
        }
    }

    return isSuccess ? (<Navigate to={reqParams === 'master-devices-customers' ? `/devicelist/master-devices-customers/details/${masterDeviceDetails && masterDeviceDetails.id}` : `/devicelist/master-devices/details/${masterDeviceDetails && masterDeviceDetails.id}`} />) : (
        <React.Fragment>
            <div className="page-content">
                <Row>
                    <Col lg="12">
                        <Card>
                            <CardBody>
                                <CardTitle className='d-flex justify-content-between align-items-center border-bottom border-secondary'>
                                    <h5 className="fw-bold">UPDATE ROOM</h5>
                                    <Link className="text-dark" to={reqParams === 'master-devices-customers' ? `/devicelist/master-devices-customers/details/${masterDeviceDetails && masterDeviceDetails.id}` : `/devicelist/master-devices/details/${masterDeviceDetails && masterDeviceDetails.id}`}>
                                        <i className="mdi mdi-close fs-2"></i>
                                    </Link>
                                </CardTitle>
                                {errorMessage && (
                                    <Message
                                        type="danger"
                                        defaultMessage={errorMessage}
                                        baseClassName="alert"
                                    />
                                )}
                                <div id="progrss-wizard" className="twitter-bs-wizard">
                                    <ul className="twitter-bs-wizard-nav nav-justified nav nav-pills">
                                        <NavItem className={classnames({ active: activeTabwiz === 1, })}>
                                            <NavLink
                                                className={(classnames({ active: activeTabwiz === 1 }))}
                                                onClick={() => toggleTabwiz(1)}
                                            >
                                                <span className="step-number">01</span>
                                                <span className="step-title" style={{ paddingLeft: "10px" }}>Room Details</span>
                                            </NavLink>
                                        </NavItem>
                                        <NavItem className={classnames({ active: activeTabwiz === 2 })}>
                                            <NavLink
                                                className={(classnames({ active: activeTabwiz === 2 }))}
                                                onClick={() => toggleTabwiz(2)}
                                            >
                                                <span className="step-number">02</span>
                                                <span className="step-title" style={{ paddingLeft: "10px" }}>Switch Details</span>
                                            </NavLink>
                                        </NavItem>
                                        <NavItem className={classnames({ active: activeTabwiz === 3 })}>
                                            <NavLink
                                                className={(classnames({ active: activeTabwiz === 3 }))}
                                                onClick={() => toggleTabwiz(4)}
                                            >
                                                <span className="step-number">03</span>
                                                <span className="step-title" style={{ paddingLeft: "10px" }}>Confirm Details</span>
                                            </NavLink>
                                        </NavItem>
                                    </ul>
                                    <div id="bar" className="my-4">
                                        <Progress
                                            value={40 * activeTabwiz}
                                            color="success"
                                            animated
                                        />
                                    </div>
                                    <TabContent activeTab={activeTabwiz} className="twitter-bs-wizard-tab-content">
                                        <TabPane tabId={1}>
                                            <Form>
                                                <Row>
                                                    <Col lg="6">
                                                        <FormGroup className="mb-3">
                                                            <Label htmlFor="basicpill-firstname-input12">
                                                                Room Name<span className="text-danger">*</span>
                                                            </Label>
                                                            <Input
                                                                autoFocus
                                                                type="text"
                                                                name="roomName"
                                                                placeholder="Enter room name"
                                                                onChange={handleInputChange1}
                                                                value={deviceDetails.roomName}
                                                                invalid={form && form.formUpdateRoom
                                                                    && form.formUpdateRoom.errors1 &&
                                                                    form.formUpdateRoom.errors1.roomName}
                                                            />
                                                            <FormFeedback>
                                                                {form && form.formUpdateRoom
                                                                    && form.formUpdateRoom.errors1 &&
                                                                    form.formUpdateRoom.errors1.roomName}
                                                            </FormFeedback>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col lg="6">
                                                        <FormGroup className="mb-3">
                                                            <Label htmlFor="basicpill-lastname-input22">
                                                                Room No<span className="text-danger">*</span>
                                                            </Label>
                                                            <Input
                                                                type="number"
                                                                name="roomNo"
                                                                placeholder="Enter room no"
                                                                disabled={isEndUser}
                                                                onChange={handleInputChange1}
                                                                value={deviceDetails.roomNo}
                                                                invalid={form && form.formUpdateRoom
                                                                    && form.formUpdateRoom.errors1 &&
                                                                    form.formUpdateRoom.errors1.roomNo}
                                                            />
                                                            <FormFeedback>
                                                                {form && form.formUpdateRoom
                                                                    && form.formUpdateRoom.errors1 &&
                                                                    form.formUpdateRoom.errors1.roomNo}
                                                            </FormFeedback>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col lg="6">
                                                        <FormGroup className="mb-3">
                                                            <Label htmlFor="basicpill-phoneno-input32">
                                                                Group
                                                            </Label>
                                                            <Async
                                                                id="new_group"
                                                                name="new_group"
                                                                placeholder="Select group"
                                                                defaultOptions
                                                                loadOptions={handleLoadGroups}
                                                                onChange={AddGroupChange}
                                                                openMenuOnFocus={true}
                                                                menuPortalTarget={document.body}
                                                                value={selectedGroup}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </Form>
                                        </TabPane>
                                        <TabPane tabId={2}>
                                            <div>
                                                <Form>
                                                    <Row>
                                                        <Col lg="10" md="12" sm="12">
                                                            <FormGroup className="mb-3">
                                                                {/* <hr className="form-separator" /> */}
                                                                <Row>
                                                                    <Col md={12}>
                                                                        <h5 className="mt-0 text-bold">Switches</h5>
                                                                        {isEndUser ?
                                                                            <p>Here you can edit the switch names and categories.</p> :
                                                                            <p>Here you can edit the switch names, categories, numbers and enable or disable the switches.</p>
                                                                        }
                                                                    </Col>
                                                                </Row>
                                                                <Row className="align-items-center text-center">
                                                                    <Col md={4}>
                                                                        <FormGroup className="mb-0">
                                                                            <Label onClick={() => handleSort('switchName')} style={{ cursor: "pointer" }}>
                                                                                Name<span className="text-danger">*</span>&nbsp;
                                                                                {sortOrder === 'switchName' && (
                                                                                    <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                                                                                )}
                                                                            </Label>
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col md={3}>
                                                                        <FormGroup className="mb-0">
                                                                            <Label onClick={() => handleSort('switchCategory')} style={{ cursor: "pointer" }}>
                                                                                Category&nbsp;
                                                                                {sortOrder === 'switchCategory' && (
                                                                                    <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                                                                                )}
                                                                            </Label>
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col md={3}>
                                                                        <FormGroup className="mb-0">
                                                                            <Label onClick={() => handleSort('switchNo')} style={{ cursor: "pointer" }}>
                                                                                Number<span className="text-danger">*</span>&nbsp;
                                                                                {sortOrder === 'switchNo' && (
                                                                                    <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                                                                                )}
                                                                            </Label>
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col md={1}>
                                                                        <FormGroup className="mb-0">
                                                                            <Label>Scheduler</Label>
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col md={1}>
                                                                        <FormGroup className="mb-0">
                                                                            <Label >Enabled</Label>
                                                                        </FormGroup>
                                                                    </Col>
                                                                </Row>
                                                                {switchList && switchList.map((switchData, index) => (
                                                                    <Row key={index} className="align-items-center pb-2">
                                                                        <Col md={4}>
                                                                            <FormGroup>
                                                                                <Input
                                                                                    type="text"
                                                                                    name="switchName"
                                                                                    placeholder="Enter switch name"
                                                                                    onChange={(e) => switchDataOnChange(e, switchData, index)}
                                                                                    value={switchData.switchName || ""}
                                                                                    invalid={form && form.formUpdateRoom
                                                                                        && form.formUpdateRoom.errors2[index] &&
                                                                                        form.formUpdateRoom.errors2[index].switchNameError}
                                                                                    disabled={Number(switchData.switchNo) === 2 || Number(switchData.switchNo) === 3}
                                                                                />
                                                                                <FormFeedback>
                                                                                    {form && form.formUpdateRoom
                                                                                        && form.formUpdateRoom.errors2[index] &&
                                                                                        form.formUpdateRoom.errors2[index].switchNameError}
                                                                                </FormFeedback>
                                                                            </FormGroup>
                                                                        </Col>
                                                                        <Col md={3}>
                                                                            <FormGroup>
                                                                                <Async
                                                                                    name="switchCategory"
                                                                                    placeholder="Select switch category"
                                                                                    loadOptions={handleCategoriesOption}
                                                                                    defaultOptions
                                                                                    onChange={(value) => switchDataOnSelect(value, switchData, index)}
                                                                                    value={switchData.switchCategory ? { label: switchData.switchCategory, value: switchData.switchCategory } : { label: "Select", value: null }}
                                                                                    isSearchable
                                                                                    menuPortalTarget={document.body}
                                                                                    isDisabled={Number(switchData.switchNo) === 2 || Number(switchData.switchNo) === 3}
                                                                                />
                                                                            </FormGroup>
                                                                        </Col>
                                                                        <Col md={3}>
                                                                            <FormGroup>
                                                                                <Input
                                                                                    className="text-center"
                                                                                    type="number"
                                                                                    name="switchNo"
                                                                                    placeholder="Enter switch no"
                                                                                    disabled={isEndUser}
                                                                                    onChange={(e) => switchDataOnChange(e, switchData, index)}
                                                                                    onKeyDown={
                                                                                        (e) => ["e", "E", "+", "-", ".", "ArrowUp", "ArrowDown"].includes(e.key) && e.preventDefault()
                                                                                    }
                                                                                    onWheel={(e) => e.target.blur()}
                                                                                    value={switchData.switchNo}
                                                                                    invalid={form && form.formUpdateRoom
                                                                                        && form.formUpdateRoom.errors2[index] &&
                                                                                        form.formUpdateRoom.errors2[index].switchNoError}
                                                                                />
                                                                                <FormFeedback>
                                                                                    {form && form.formUpdateRoom
                                                                                        && form.formUpdateRoom.errors2[index] &&
                                                                                        form.formUpdateRoom.errors2[index].switchNoError}
                                                                                </FormFeedback>
                                                                            </FormGroup>
                                                                        </Col>
                                                                        <Col md={1} className="d-flex justify-content-center mb-3">
                                                                            <Dropdown
                                                                                isOpen={
                                                                                    open && open.filter((i) => i.id === switchData.id).length > 0 ?
                                                                                        open.filter((i) => i.id === switchData.id)[0].isOpen
                                                                                        : false
                                                                                }
                                                                                onClick={(e) => {
                                                                                    if (!(Number(switchData.switchNo) === 2 || Number(switchData.switchNo) === 3)) {
                                                                                        handleSchedulerData(e, switchData.id, switchData.switchName)
                                                                                    }
                                                                                }}
                                                                                toggle={(e) => {
                                                                                    e.preventDefault();
                                                                                    setOpen([]);
                                                                                    setSchedulerDetails();
                                                                                }}
                                                                            >
                                                                                <DropdownToggle className="bg-white border-0" disabled={Number(switchData.switchNo) === 2 || Number(switchData.switchNo) === 3}>
                                                                                    <i class="fas fa-calendar-week fs-4 text-secondary"></i>
                                                                                </DropdownToggle>
                                                                                <DropdownMenu style={{ backgroundColor: "#E7F2F8", maxHeight: "400px", overflowY: "auto" }} onClick={(e) => e.preventDefault()}>
                                                                                    <div className="pt-2 pb-0 px-3">
                                                                                        <div className="fs-5 fw-bold mb-2 text-nowrap">Switch Name : {schedulerName}</div>
                                                                                        {schedulerLoading ?
                                                                                            <VWLoading height={40} width={40} />
                                                                                            : schedulerDetails && schedulerDetails.length > 0 ?
                                                                                                schedulerDetails.map((data) => {
                                                                                                    const isSunday = data.days && data.days.filter((day) => day === "sunday").length > 0;
                                                                                                    const isMonday = data.days && data.days.filter((day) => day === "monday").length > 0;
                                                                                                    const isTuesday = data.days && data.days.filter((day) => day === "tuesday").length > 0;
                                                                                                    const isWednesday = data.days && data.days.filter((day) => day === "wednesday").length > 0;
                                                                                                    const isThursday = data.days && data.days.filter((day) => day === "thursday").length > 0;
                                                                                                    const isFriday = data.days && data.days.filter((day) => day === "friday").length > 0;
                                                                                                    const isSaturday = data.days && data.days.filter((day) => day === "saturday").length > 0;
                                                                                                    return (
                                                                                                        <Card className=" p-2 pb-0 mb-2 shadow-lg">
                                                                                                            <div className="d-flex text-nowrap gap-4 mb-2 ">
                                                                                                                <div className="d-flex align-items-center">
                                                                                                                    <div></div>
                                                                                                                    <div><span className="fw-bold">Time : </span>{data.actionTime.slice(0, -3)} <i class="fas fa-clock text-primary" /></div>
                                                                                                                </div>
                                                                                                                <div><span className="fw-bold">Switch Status :</span> {data.status ? <Badge color="primary" pill>ON</Badge> : <Badge color="danger" pill>OFF</Badge>}</div>
                                                                                                            </div>
                                                                                                            <div className="d-flex gap-2 align-items-center justify-content-center pb-2">
                                                                                                                <Card color={isSunday ? "primary" : "secondary"} className="px-2 py-1 mb-0 text-white">S</Card>
                                                                                                                <Card color={isMonday ? "primary" : "secondary"} className="px-2 py-1 mb-0 text-white">M</Card>
                                                                                                                <Card color={isTuesday ? "primary" : "secondary"} className="px-2 py-1 mb-0 text-white">T</Card>
                                                                                                                <Card color={isWednesday ? "primary" : "secondary"} className="px-2 py-1 mb-0 text-white">W</Card>
                                                                                                                <Card color={isThursday ? "primary" : "secondary"} className="px-2 py-1 mb-0 text-white">T</Card>
                                                                                                                <Card color={isFriday ? "primary" : "secondary"} className="px-2 py-1 mb-0 text-white">F</Card>
                                                                                                                <Card color={isSaturday ? "primary" : "secondary"} className="px-2 py-1 mb-0 text-white">S</Card>
                                                                                                            </div>
                                                                                                        </Card>
                                                                                                    )
                                                                                                })
                                                                                                : schedulerError && typeof (schedulerError) === "string" ?
                                                                                                    <Message
                                                                                                        type="danger"
                                                                                                        defaultMessage={schedulerError}
                                                                                                        baseClassName="alert"
                                                                                                    />
                                                                                                    :
                                                                                                    <div className="text-danger fs-6 text-center text-nowrap">
                                                                                                        <i class="fas fa-database"></i> &nbsp; No Routine Found.
                                                                                                    </div>
                                                                                        }
                                                                                    </div>
                                                                                </DropdownMenu>
                                                                            </Dropdown>
                                                                        </Col>
                                                                        <Col md={1} className="d-flex justify-content-center mb-3">
                                                                            <FormGroup check >
                                                                                <Input
                                                                                    type="checkbox"
                                                                                    name="isEnabled"
                                                                                    onChange={(e) => switchDataOnChange(e, switchData, index)}
                                                                                    checked={switchData && switchData.isEnabled}
                                                                                    disabled={isEndUser || switchData.disabled}
                                                                                />
                                                                            </FormGroup>
                                                                        </Col>
                                                                    </Row>
                                                                ))}
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                </Form>
                                            </div>
                                        </TabPane>
                                        <TabPane tabId={3}>
                                            <Row className="justify-content-center">
                                                <Col lg="12">
                                                    {isPending ? <VWLoading /> :
                                                        <div className="text-center">
                                                            <div className="mb-4">
                                                                <i className="mdi mdi-check-circle-outline text-success display-4" />
                                                            </div>
                                                            <div>
                                                                <h5>Confirm Details</h5>
                                                                <p className="text-muted">
                                                                    The room details are going to update. Are you sure to update?
                                                                </p>
                                                            </div>
                                                            <FormGroup>
                                                                <Button color="success" onClick={handleUpdateRoomDetails}>Submit</Button>
                                                                <Link className="btn btn-danger ms-4" to={reqParams === 'master-devices-customers' ? `/devicelist/master-devices-customers/details/${masterDeviceDetails && masterDeviceDetails.id}` : `/devicelist/master-devices/details/${masterDeviceDetails && masterDeviceDetails.id}`}>
                                                                    Cancel
                                                                </Link>
                                                            </FormGroup>
                                                        </div>}
                                                </Col>
                                            </Row>
                                        </TabPane>
                                    </TabContent>
                                    <ul className="pager wizard twitter-bs-wizard-pager-link">
                                        <li className={activeTabwiz === 1 ? "previous disabled me-2" : "previous me-2"}>
                                            {activeTabwiz !== 1 &&
                                                <Button
                                                    color='primary'
                                                    onClick={() => toggleTabwiz(activeTabwiz - 1)}
                                                    disabled={activeTabwiz === 1}>
                                                    Previous
                                                </Button>}
                                        </li>
                                        <li className={activeTabwiz === 3 ? "next disabled" : "next"}>
                                            {activeTabwiz !== 3 && <Button
                                                color='primary'
                                                onClick={() => toggleTabwiz(activeTabwiz + 1)}
                                                disabled={activeTabwiz === 3}>
                                                Next
                                            </Button>
                                            }
                                        </li>
                                    </ul>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

            </div>
        </React.Fragment >
    );
};

const mapStateToProps = (state) => ({
    form: state.form.form,
    isPending: state.deviceDetails.isUpdateRoomDetailsPending,
    errorMessage: state.deviceDetails.updateRoomDetailsErrorMessage,
    masterDeviceDetails: state.deviceDetails.masterDevice,
    // switchList: state.deviceDetails.switchList,
    isSuccess: state.deviceDetails.isUpdateRoomSuccess,
    currentProfile: state.login.currentProfile,
});

const mapDispatchToProps = (dispatch) => ({
    updateForm: (updateRoom) => dispatch(updateForm(updateRoom)),
    clearUpdateRoomDetailsError: () => dispatch(clearUpdateRoomDetailsError()),
    updateRoomDetails: (deviceId, masterDeviceId, deviceDetails,) => dispatch(updateRoomDetails(deviceId, masterDeviceId, deviceDetails)),
    getAssignableGroupsForAsyncSelect: (masterDeviceId, searchValue, callback) => dispatch(getAssignableGroupsForAsyncSelect(masterDeviceId, searchValue, callback)),
    getAssignableSwitchCategoryForAsyncSelect: (searchValue, callback) => dispatch(getAssignableSwitchCategoryForAsyncSelect(searchValue, callback)),
    updateSwitchDetails: (data) => dispatch(updateSwitchDetails(data)),
    getSchedulerDetails: (id) => dispatch(getSchedulerDetails(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FormWizard);